import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { MappedName, UserSessionMetricsByDim } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { FunctionComponent } from 'react'
import { useAnalyticsQueryTanstack } from '~/api/analytics/analytics-query.api'
import { useAuthenticatedUser } from '~/auth/user.hooks'
import { useBreakdownTabs } from '~/hooks/useBreakdownTabs'
import { Context } from '~/state'
import { WithClassName } from '~/types/utils'
import { PureUserSessionBreakdown } from './PureUserSessionBreakdown'

type UserSessionBreakdownProps = WithClassName & {
  context: Context
  currencySymbol: CurrencySymbol
  dimension: Dimension
  onRowClick: (name: MappedName) => void
  onTabChange: (dimension: Dimension) => void
}

const DIMENSIONS: Dimension[] = ['tagId', 'device', 'country']

export const UserSessionBreakdown: FunctionComponent<UserSessionBreakdownProps> = ({ className, dimension, onTabChange, onRowClick, context, currencySymbol }) => {
  const user = useAuthenticatedUser()
  const tabsConfig = useBreakdownTabs(user, ['tagId', 'device', 'country'])

  const analyticsQuery = useAnalyticsQueryTanstack<UserSessionMetricsByDim>('user-session.metrics.by.dim', DIMENSIONS, context, { dimension })

  return (
    <PureUserSessionBreakdown
      className={className}
      isLoading={analyticsQuery.isFetching}
      error={!!analyticsQuery.error}
      empty={!analyticsQuery.isFetching && !analyticsQuery?.data?.name?.length}
      onRefreshClick={() => analyticsQuery.refetch()}
      rawData={analyticsQuery.data}
      onTabChange={onTabChange}
      currencySymbol={currencySymbol}
      onRowClick={onRowClick}
      onSortChange={() => {}}
      tabsConfig={tabsConfig}
    />
  )
}
